import { StandardEvents } from '@shopify/events';
import { showMobileCartConfirmation } from './wb-mobile-cart-confirmation.js?v=1792463200';
const visible=r=>r&&r.width>0&&r.height>0&&r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth;
let clicked;
document.addEventListener('click',event=>{const button=event.target.closest('button');if(button)clicked={button,time:performance.now()};},true);
async function fly(src,origin,index){
 await new Promise(resolve=>setTimeout(resolve,200+index*110));
 const target=document.querySelector('.wb-header .header-actions__cart-icon');if(!target)return;
 const dest=target.getBoundingClientRect();
 let receiver;
 const ex=Math.max(28,Math.min(innerWidth-28,dest.left+dest.width/2)),ey=Math.max(28,Math.min(innerHeight-28,dest.top+dest.height/2));
 if(!visible(dest)){
  receiver=document.createElement('span');receiver.setAttribute('aria-hidden','true');
  const svg=target.querySelector('svg');if(svg)receiver.append(svg.cloneNode(true));
  Object.assign(receiver.style,{position:'fixed',left:`${ex-20}px`,top:`${ey-20}px`,width:'40px',height:'40px',padding:'8px',background:'#fff',color:'#111',borderRadius:'50%',pointerEvents:'none',zIndex:'9999'});document.body.append(receiver);
 }
 const image=document.createElement('img');image.src=src;image.alt='';image.setAttribute('aria-hidden','true');
 Object.assign(image.style,{position:'fixed',left:'0',top:'0',width:'72px',height:'90px',objectFit:'cover',borderRadius:'6px',pointerEvents:'none',zIndex:'9999',boxShadow:'0 6px 20px #0003'});document.body.append(image);
 const x=origin.x-36,y=origin.y-45;
 try{await image.animate([{transform:`translate(${x}px,${y}px) scale(1)`,opacity:1},{transform:`translate(${ex-36}px,${ey-45}px) scale(.15)`,opacity:.25}],{duration:650,easing:'cubic-bezier(.35,0,.65,1)',fill:'forwards'}).finished;}catch{}finally{image.remove();receiver?.remove();}
}
document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
 if(event.action!=='add'||!event.promise)return;
 const scope=event.target instanceof Element?event.target:document;
 const button=clicked&&performance.now()-clicked.time<1500?clicked.button:scope.querySelector('button[type="submit"],.wb-pair-add,.wb-wishlist-add');
 const rect=(button||scope).getBoundingClientRect?.();
 const origin={x:visible(rect)?rect.left+rect.width/2:innerWidth/2,y:visible(rect)?rect.top+rect.height/2:innerHeight/2};
 const media=scope.querySelector('[data-product-variant-media]')?.dataset.productVariantMedia;
 const fallback=media||scope.querySelector('img')?.src;
 const ids=(event.lines||[]).map(line=>String(line.merchandiseId).split('/').pop());
 event.promise.then(result=>{
  if(!result||result.detail?.didError)return;
  document.dispatchEvent(new CustomEvent('wb:cart-added'));
  if(matchMedia('(max-width:749px)').matches){
   showMobileCartConfirmation({result,lines:event.lines||[],opener:button,source:scope});
   return;
  }
  return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const items=result.detail?.items||[];
  const images=ids.map(id=>{const item=items.find(i=>String(i.variant_id||i.id)===id);return item?.featured_image?.url||item?.image;}).filter(Boolean);
  if(!images.length&&fallback)images.push(fallback);
  images.forEach((src,index)=>fly(src,origin,index));
 }).catch(()=>{});
});
